import React from 'react';
import * as XLSX from 'xlsx';
import * as FileSaver from 'file-saver';
import downloadIcon from "assets/img/download-30.png";

const ExportToExcel = ({ history }) => {
    const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    const fileExtension = '.xlsx';
    
    const flattenObject = (obj, parent = '', res = {}) => {
        for (let key in obj) {
            const propName = parent ? `${parent}.${key}` : key;
            if (typeof obj[key] === 'object' && !Array.isArray(obj[key])) {
                flattenObject(obj[key], propName, res);
            } else {
                res[propName] = obj[key];
            }
        }
        return res;
    };

    const formatedOrders = (ordersDict) => {
        return Object.values(ordersDict).map(orderDict => 
            Object.entries(orderDict).map(([key, value]) => `${key}: ${JSON.stringify(value)}`).join(', ')
        ).join(' || ');
    };
    
    const exportToCSV = (history, fileName) => {
        const data = Object.keys(history).reverse().flatMap(date => { 
            return history[date].map(bus => ({
                date,
                bus: bus.bus,
                terminal: bus.terminal,
                skids: bus.skids,
                weight: `${bus.weight} (${bus.p_weight}%)`,
                length: `${bus.total_length} (${bus.p_length}%)`,
                height: bus.height,
                orders: bus.orders ? formatedOrders(bus.orders) : '',
                bus_id: bus.bus_id // Add bus_id for unique row identification
            }));
        });
    
        // Flatten each object in the array
        const flattenedData = data.map(item => flattenObject(item));
    
        const ws = XLSX.utils.json_to_sheet(flattenedData);
        const wb = { Sheets: { data: ws }, SheetNames: ['data'] };
        const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
        const blob = new Blob([excelBuffer], { type: fileType });
        FileSaver.saveAs(blob, fileName + fileExtension);
    };

    return (
        <span 
            onClick={() => exportToCSV(history, "busesHistory")}
            style={{ cursor: 'pointer' }}>
            <img src={downloadIcon} alt="Download" />
        </span>
    );
};

export default ExportToExcel;
